import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fontsource/mulish';

// Match generated style tags to the per-response CSP nonce. Vite development
// serves the placeholder unchanged and does not send the production CSP header.
const nonce = document.querySelector<HTMLMetaElement>(
  'meta[name="csp-nonce"]'
)?.content;
const emotionCache = createCache({
  key: 'css',
  nonce: nonce === '__CSP_NONCE__' ? undefined : nonce
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <CacheProvider value={emotionCache}>
      <App />
    </CacheProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
